<mat-drawer-container hasBackdrop>
  <mat-drawer
    autoFocus="false"
    #drawer
    mode="over"
    position="end"
    (closed)="closeRightSidebar()"
  >
    <app-right-sidebar-container
      [title]="'Upload Invoice'"
      [footerSubmitCustomLabel]="isEditing ? 'Update' : 'Add'"
      (cancel)="closeRightSidebar()"
      (submit)="onSubmit()"
      [disableSubmit]="invoiceForm.invalid || emptyAttachment()"
      [loading]="isLoading"
    >
      <div class="document-sidebar-body">
        <form
          class="animate-labels-form document-sidebar-content"
          [formGroup]="invoiceForm"
        >
          <div class="custom-form-field">
            <label for="invoiceDate"
              >Invoice Date<span class="required">*</span></label
            >
            <mat-form-field appearance="outline" class="custom-field">
              <input
                matInput
                [matDatepicker]="invoiceDatePicker"
                name="invoiceDate"
                formControlName="invoiceDate"
              />
              <mat-datepicker-toggle matIconSuffix [for]="invoiceDatePicker">
                <mat-icon
                  class="icon-btn"
                  matDatepickerToggleIcon
                  fontSet="material-icons-outlined"
                  >calendar_today</mat-icon
                >
              </mat-datepicker-toggle>
              <mat-datepicker #invoiceDatePicker></mat-datepicker>
              @if (invoiceForm.controls['invoiceDate'].errors?.['required']) {
              <mat-error> Please select Invoice Date </mat-error>
              }
            </mat-form-field>
            <app-upload-documents
              [files]="filesToUpdate"
              (uploadingEvent)="uploadingEventHandler($event)"
              (onFileRemove)="onFileRemoveHandler($event)"
              [isMulti]="false"
              #invoiceDocuments
            >
            </app-upload-documents>
            @if (emptyAttachment()) {
            <div>
              <div class="error">Please upload at least one invoice.</div>
            </div>
            }
          </div>
        </form>
      </div>
    </app-right-sidebar-container>
  </mat-drawer>
  <mat-drawer-content>
    <div class="pcs-container">
      <div class="pcs-header mb-20">
        <h3 class="pcs-title">Invoices</h3>
        @if (isAdmin()) {
        <div class="card-actions">
          <button
            mat-flat-button
            class="mr-15"
            [color]="'primary'"
            (click)="onDownloadInvoice()"
          >
            <mat-icon class="icon-btn" fontSet="material-icons-outlined"
              >download</mat-icon
            >
            Generate Invoice
          </button>
          <button
            (click)="openRightSidebar(false)"
            mat-stroked-button
            color="primary"
            class="primary"
            type="button"
          >
            <mat-icon class="icon-btn">upload</mat-icon>
            Upload new Invoice
          </button>
        </div>
        }
      </div>
      @if (isLoading) {
      <div class="loader-container">
        <app-loader />
      </div>
      } @else { @if (providerInvoices.length > 0) {
      <div class="invoices-grid">
        @for (invoice of providerInvoices; track invoice) {
        <div class="pro-card invoice-card">
          <div class="invoice-header">
            <a
              class="invoice-copies"
              (click)="downloadDocument(invoice.document)"
            >
              <mat-icon fontSet="material-icons-outlined"
                >insert_drive_file</mat-icon
              >
              <span class="invoice-copy">{{ invoice?.document?.name }}</span>
            </a>
            <div class="invoice-expiration-date-container">
              <mat-icon>schedule</mat-icon>
              <span class="invoice-expiration-date"
                >Date: {{ invoice?.invoiceDate | date : "MM/dd/yy" }}</span
              >
            </div>
          </div>
          <div class="invoice-body">
            <div class="invoice-status">
              <span>Status: </span>
              <app-status-badge
                class="status-badge"
                [text]="invoice.status"
                [status]="invoice.status == 'Unpaid' ? 'info' : 'success'"
                [size]="'large'"
              />
            </div>
            <div class="invoice-actions">
              @if (isAdmin()) {
              <button
                mat-stroked-button
                (click)="deleteInvoice(invoice)"
                [matTooltip]="'Delete'"
                class="danger outer icon-only"
              >
                <mat-icon
                  class="icon-btn card-action-icon"
                  fontSet="material-icons-outlined"
                  >delete</mat-icon
                >
              </button>
              } @if (invoice.status == 'Unpaid' && isAdmin()) {
              <button
                mat-stroked-button
                (click)="markAsPaid(invoice)"
                [matTooltip]="'Mark as paid'"
                class="success outer icon-only"
              >
                <mat-icon
                  class="icon-btn card-action-icon"
                  fontSet="material-icons-outlined"
                  >done</mat-icon
                >
              </button>
              }
              <button
                mat-stroked-button
                [matTooltip]="'Download'"
                (click)="downloadDocument(invoice.document)"
                class="primary outer icon-only"
              >
                <mat-icon
                  class="icon-btn card-action-icon"
                  fontSet="material-icons-outlined"
                  >download</mat-icon
                >
              </button>
              @if (isAdmin()) {
              <button
                mat-stroked-button
                (click)="uploadInvoice(invoice)"
                [matTooltip]="'Upload invoice'"
                class="primary icon-only fill"
              >
                <mat-icon
                  class="icon-btn card-action-icon"
                  fontSet="material-icons-outlined"
                  >upload_file_outlined</mat-icon
                >
              </button>
              }
            </div>
          </div>
        </div>
        }
      </div>
      <mat-paginator
        #paginator
        [selectConfig]="{ panelClass: 'mat-paginator-select-options' }"
        [length]="this.totalCount"
        [pageIndex]="this.currentPage"
        [pageSize]="this.pageSize"
        [pageSizeOptions]="pageSettings.pageSizeOptions"
        (page)="handlePageEvent($event)"
        aria-label="Select page"
      >
      </mat-paginator>
      } @else {
      <div class="pro-card invoice-card">
        <p class="invoice-card-empty-text">No Invoices yet</p>
      </div>
      } }
    </div>
  </mat-drawer-content>
</mat-drawer-container>
<ng-template #templateGenerateContent>
  <div class="report-container">
      <div class="custom-form-field">
        <label for="title">Select Range Date<span class="required">*</span></label>
        <mat-form-field appearance="outline" class="custom-field">
          <mat-date-range-input [formGroup]="invoiceDateRangeForm" [rangePicker]="picker">
            <input matStartDate formControlName="periodFrom" placeholder="Start date">
            <input matEndDate formControlName="periodTo" placeholder="End date">
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>

        </mat-form-field>
      </div>
  </div>
</ng-template>
<ng-template #templateGenerateActions>
  <button
    mat-flat-button
    color="primary"
    type="button"
    [disabled]="invoiceDateRangeForm.invalid"
    (click)="onSubmitDate()"
    >
    Generate
  </button>
</ng-template>
